import gButton from "@/components/g-button/g-button.vue";
import gCard from "@/components/g-card/g-card.vue";
import gPdf from "@/components/g-pdf/g-pdf.vue";
import DetalhesDoPedidoFluxoViewModel from "@/shared/view-models/DetalhesDoPedidoFluxoViewModel";
import InstrucoesCarregamentoViewModel from "@/shared/view-models/InstrucoesCarregamentoViewModel";
import PedidoDesdobramentoViewModel from "@/shared/view-models/PedidoDesdobramentoViewModel";
import Tools from "@/shared/services/tools";
import { defineComponent } from "vue";
import PedidoEmAndamentoPDF from "@/pages/Pedidos/PedidoEmAndamento/components/DetalhesPedidoEmAndamento/PDF/PedidoEmAndamentoPDF.vue";


const name = 'InstrucoesCarregamentoPedidosExpedidoFaturado'

export default defineComponent({
  name,

  components:{
    "g-button": gButton,
    "g-card": gCard,
    "g-pdf": gPdf,
    PedidoEmAndamentoPDF
  },

  props: { },

  mounted() {
    var pedId = this.$route.params.id
    this.PedidoId = pedId
    this.getDetalhesDoPedido();
    this.GetInstrucoesDeCarregamento();
    this.getPedidoDesdobramento();
   },

  updated() { },

  data() {
    return {
      detalhesDoPedidoFluxo : new DetalhesDoPedidoFluxoViewModel(),
      novoInstrucoesCarregamento : new InstrucoesCarregamentoViewModel(),
      instrucoesCarregamentoArray: [],
      pedidoDesdobramento : new PedidoDesdobramentoViewModel(),
      CompFaseArray: [],
      PedidoId: null,
      executarvisualizacao: 0,
      renderiza: false,
    }

  },

  methods: {
    formataDecimal(valor){
      return Tools.valorDecimalFormatado(valor)
    },

    formataMonetario(valor){ 
      return Tools.valorMonetario4Digitos(valor)
    },
    voltar() {
      this.$router.back()

    },

    getDetalhesDoPedido() {
      this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + `Pedido/GetDetalhesDoPedidoFluxo/${this.$route.params.id}`,
      })
        .then((response) => {
          Tools.objectCustomAssign(this.detalhesDoPedidoFluxo, Tools.captalizeKeys(response.data.data))
        })
        .catch(() => {
        });
    },

    GetInstrucoesDeCarregamento() {
      this.$isLoading(true)
      this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + `Pedido/GetInstrucoesDeCarregamento/${this.$route.params.id}/${this.$route.params.numeroParcela}`,
      })
        .then((response) => {
          if (Array.isArray(response.data.data)) {
            this.instrucoesCarregamentoArray = [];
            response.data.data.forEach(item => {
              const instrucao = new InstrucoesCarregamentoViewModel();
              Tools.objectCustomAssign(instrucao, Tools.captalizeKeys(item));
              this.instrucoesCarregamentoArray.push(instrucao);
            });
            
            if (this.instrucoesCarregamentoArray.length > 0) {
              Tools.objectCustomAssign(this.novoInstrucoesCarregamento, this.instrucoesCarregamentoArray[0]);
            }
          } else {
            Tools.objectCustomAssign(this.novoInstrucoesCarregamento, Tools.captalizeKeys(response.data.data));
          }
          this.GetComponentesEFases()
        })
        .catch(() => {
        }).finally(() => this.$isLoading(false))
    },

    getPedidoDesdobramento() {
      this.$isLoading(true)
      this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + `Pedido/GetPedidoDesdobramento/${this.$route.params.id}/${this.$route.params.numeroParcela}`,
      })
        .then((response) => {
          Tools.objectCustomAssign(this.pedidoDesdobramento, Tools.captalizeKeys(response.data.data))
        })
        .catch(() => {
        }).finally(() => this.$isLoading(false))
    },

    GetComponentesEFases(){
      this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + `Pedido/GetPedidosComponentesParcela/${this.$route.params.id}/${this.$route.params.numeroParcela}`,
      })
        .then((response) => {
          this.CompFaseArray = response.data.data;
        })
        .catch(() => {
        });
    },
    imprimir()
    {
      this.renderiza = true
      this.PedidoId = this.$route.params.id
      this.executarvisualizacao++
    },
    gerarPdf() {
    },
  },

  computed: { }
});